export default __webpack_public_path__ + "static/FS2S-InHub-149-c820e0bbbd80b0b824134b5b9b605335.jpg";